/**
 * Composer 작성 탭 캔버스의 등록형(widget:'registered') 폼 위젯 레지스트리 (host=admin).
 *
 * InputWidget.widgetKey로 이 맵에서 위젯을 찾아 ComposerWidgetTreeView에 주입한다
 * (코어/범용 렌더러에는 도메인 로직 없음 — 미등록 키는 안내 placeholder로 처리).
 *
 * web(COMPOSED_FORM_WIDGETS)과 별개 — admin은 슈퍼관리자 인증 API로 조회하는 얇은 read-only 구현.
 */
import type { ComposerRegisteredFormWidget } from '@safetyhub/report-composer';
import { COMPOSED_ROW_FORM_WIDGETS, RiskCriteriaDetailWidget } from '@safetyhub/report-composer';

export const ADMIN_COMPOSER_FORM_WIDGETS: Record<string, ComposerRegisteredFormWidget> = {
  // rc 공용 구현(web 실폼과 동일 컴포넌트) — 캔버스가 placeholder 대신 배포본 동형 렌더
  // (WYSIWYG, 결정 2026-07-07-composer-template-variables 개정 5 §4).
  'risk-criteria-detail': RiskCriteriaDetailWidget,
  // 행 위젯(위험도·개선계획)을 폼 위젯 계약으로 브리지 — 캔버스 라이브 모드에서 실렌더(P4b).
  ...COMPOSED_ROW_FORM_WIDGETS,
};
